export enum SortLabels {
  TRENDING = 'Trending',
  MOST_RECENT = 'Recent',
  CONTENT_TYPE = 'Content Type',
}
